import styled from 'styled-components';

export const Section = styled.section`
  padding: ${props => `${props.theme.verticalSpacing(2)} 0`};
  @media only screen and (min-width: ${props => props.theme.tablet}px) {
    padding: ${props => `${props.theme.verticalSpacing(4)} 0 ${props.theme.verticalSpacing(5)}`};
  }
`;

export default Section;